export const PROXY = "https://okabebot-pixiv.herokuapp.com";
export const PIXIV_HOST = "https://i.pximg.net";